import { useMemo, useState } from 'react';
import { StatusTagEnum } from '@tryhackme/thm-ui-components';
import { RoomTask } from 'src/common/interfaces/tasks';
import { RunningInstance } from 'src/common/interfaces/instances';
import { ContentButton } from '../accordion/content-button';
import { VirtualEnvironmentMachine } from './virtual-environment-machine';
import { StyledContentButtonWrapper } from './virtual-environment-setup.styles';
type VirtualEnvironmentTargetMachineProps = {
  roomCode: string;
  hasSeenVmStart: boolean;
  task: Omit<RoomTask, 'deadline' | 'created' | 'questions'>;
  activeMachine?: RunningInstance;
  hasMultipleVMs: boolean;
  isAttackboxWidgetV1ExperimentEnabled: boolean;
  isAttackboxWidgetV2ExperimentEnabled: boolean;
  isAnotherMachineRunning: boolean;
};
export const VirtualEnvironmentTargetMachine: React.FC<VirtualEnvironmentTargetMachineProps> = ({
  roomCode,
  hasSeenVmStart,
  task,
  activeMachine,
  hasMultipleVMs,
  isAttackboxWidgetV1ExperimentEnabled,
  isAttackboxWidgetV2ExperimentEnabled,
  isAnotherMachineRunning
}) => {
  const [isDesktopOnlyAccessPopupOpen, setIsDesktopOnlyAccessPopupOpen] = useState(false);
  const isConnected = !!activeMachine;
  const shouldDisplayButton = useMemo(() => {
    if (!isAttackboxWidgetV2ExperimentEnabled) {
      return true;
    }
    return task.uploadId !== activeMachine?.uploadId;
  }, [activeMachine?.uploadId, isAttackboxWidgetV2ExperimentEnabled, task.uploadId]);
  return <VirtualEnvironmentMachine title={`Target machine${hasMultipleVMs ? ` - Task ${task.taskNo}` : ''}`} tooltipText="Target/task machines are specific VMs that you interact with during your tasks. They are the targets you will exploit or work with to solve challenges. Each Task Machine has a unique IP address." tagTitle={isConnected && !isAnotherMachineRunning ? 'On' : 'Off'} tagStatus={isConnected && !isAnotherMachineRunning ? StatusTagEnum.GREEN : StatusTagEnum.RED} data-sentry-element="VirtualEnvironmentMachine" data-sentry-component="VirtualEnvironmentTargetMachine" data-sentry-source-file="virtual-environment-target-machine.tsx">
      <StyledContentButtonWrapper data-sentry-element="StyledContentButtonWrapper" data-sentry-source-file="virtual-environment-target-machine.tsx">
        {shouldDisplayButton && <ContentButton roomCode={roomCode} isDesktopOnlyAccessPopupOpen={isDesktopOnlyAccessPopupOpen} setIsDesktopOnlyAccessPopupOpen={setIsDesktopOnlyAccessPopupOpen} hasSeenVmStart={hasSeenVmStart} applyDefaultStyles={false} isAttackboxWidgetV2ExperimentEnabled={isAttackboxWidgetV2ExperimentEnabled} isAttackboxWidgetV1ExperimentEnabled={isAttackboxWidgetV1ExperimentEnabled} {...task} />}
      </StyledContentButtonWrapper>
    </VirtualEnvironmentMachine>;
};